module.exports = __webpack_public_path__ + "img/compass-slash.fcd371af.svg";